
type Image = {
  image: string;
  isBuilding: boolean;
  order: number;
  url: string;
};

type Props = {
  images: Image[];
  handleImageClick: (index: number) => void;
};

const renderFullWidthImage = (
  image: Image,
  index: number,
  handleImageClick: (index: number) => void,
  altText: string,
) => (
  <div key={`full-${index}`} className='w-full mb-2'>
    <div
      className='relative cursor-pointer'
      onClick={() => handleImageClick(index)}
    >
      <img
        src={`https://ik.imagekit.io/officehub/tr:w-1600,f-avif/${image.url}` || "/placeholder.svg"}
        alt={`${altText} - Image ${image.order}`}
        className='w-full h-[360px] md:h-[469px] object-cover rounded-lg'
      />

    </div>
  </div>
);

const renderHalfWidthImages = (
  firstImage: Image,
  secondImage: Image,
  firstIndex: number,
  handleImageClick: (index: number) => void,
  altText: string,
) => (
  <div key={`half-row-${firstIndex}`} className='flex w-full gap-2 mb-2'>
    {[firstImage, secondImage].map((img, idx) => (
      <div
        key={`${img.url}-${idx}`}
        className='w-1/2 cursor-pointer relative'
        onClick={() => handleImageClick(firstIndex + idx)}
      >
        <img
          src={`https://ik.imagekit.io/officehub/tr:w-800,f-avif/${img.url}` || "/placeholder.svg"}
          alt={`${altText} - Image ${img.order}`}
          className='w-full h-[260px] md:h-[317px] object-cover rounded-lg'
        />

      </div>
    ))}
  </div>
);

const renderSingleImage = (
  image: Image,
  index: number,
  handleImageClick: (index: number) => void,
  altText: string,
) => (
  <div key={`single-${index}`} className='w-full mb-2'>
    <div
      className='relative cursor-pointer'
      onClick={() => handleImageClick(index)}
    >
      <img
        src={`https://ik.imagekit.io/officehub/tr:w-1600,f-avif/${image.url}` || "/placeholder.svg"}
        alt={`${altText} - Image ${image.order}`}
        className='w-full h-[469px] object-cover rounded-lg'
      />
    </div>
  </div>
);

const GalleryLayout: React.FC<Props> = ({ images, handleImageClick, altText }) => {
  const galleryItems = [];
  for (let i = 0; i < images.length; i++) {
    if (i % 3 === 0) {
      galleryItems.push(renderFullWidthImage(images[i], i, handleImageClick, altText));
    } else if (i % 3 === 1 && i + 1 < images.length) {
      galleryItems.push(
        renderHalfWidthImages(images[i], images[i + 1], i, handleImageClick, altText),
      );
      i++; // Skip the next image as we've already included it
    } else {
      galleryItems.push(renderSingleImage(images[i], i, handleImageClick, altText));
    }
  }
  return <>{galleryItems}</>;
};

export default GalleryLayout;
